import { LOCALES } from '@/config/site';
import { absoluteUrl, buildHreflangLinkTags, localeUrl } from '@/seo/hreflang';
import { pickTdk } from '@/content/seo/tdkPages';
import { blogPosts } from '@/content/seo/blog-data';

/** 构建带语言前缀的路径（与 localeUrl / canonical / sitemap 一致：非根路径以 / 收尾） */
export function fullPath(localeCode, segment) {
	const seg = (segment || '').replace(/^\/+|\/+$/g, '');
	if (!seg) return localeUrl(localeCode, '');
	return localeUrl('en', seg);
}

function routeMeta(localeCode, segment, pageKey) {
	const t = pickTdk(pageKey, localeCode);
	return {
		locale: localeCode,
		hreflangSegment: segment,
		title: t.title,
		description: t.description,
		keywords: t.keywords,
		link: [{ rel: 'canonical', href: absoluteUrl(localeCode, segment) }],
		hreflangHtml: buildHreflangLinkTags(segment),
	};
}

function modMeta(locale, mod) {
	const titles = {
		fmwhatsapp: {
			en: {
				title: 'FMWhatsApp APK Download Latest Version',
				description:
					'What FMWhatsApp is, key features, FMWhatsApp vs GBWhatsApp, how to download and install safely, privacy notes, FAQ, and links to YoWhatsApp, OGWhatsApp, and the download hub.',
				keywords: 'fmwhatsapp, fm whatsapp download, whatsapp mod',
			},
			in: {
				title: 'FMWhatsApp APK डाउनलोड नवीनतम संस्करण',
				description: 'FMWhatsApp क्या है, इसकी मुख्य सुविधाएँ, GBWhatsApp से तुलना, सुरक्षित डाउनलोड व इंस्टॉल, गोपनीयता नोट्स और FAQ।',
				keywords: 'fmwhatsapp, fm whatsapp download, whatsapp mod',
			},
			es: {
				title: 'Descargar FMWhatsApp APK última versión',
				description: 'Qué es FMWhatsApp, funciones clave, comparación con GBWhatsApp, descarga e instalación segura, privacidad y FAQ.',
				keywords: 'fmwhatsapp, fm whatsapp download, whatsapp mod',
			},
			pt: {
				title: 'Baixar FMWhatsApp APK última versão',
				description: 'O que é FMWhatsApp, recursos principais, comparação com GBWhatsApp, download seguro, instalação e FAQ.',
				keywords: 'fmwhatsapp, fm whatsapp download, whatsapp mod',
			},
			id: {
				title: 'Unduh FMWhatsApp APK versi terbaru',
				description: 'Apa itu FMWhatsApp, fitur utama, perbandingan dengan GBWhatsApp, unduhan aman, instalasi, privasi, dan FAQ.',
				keywords: 'fmwhatsapp, fm whatsapp download, whatsapp mod',
			},
		},
		yowhatsapp: {
			en: {
				title: 'YoWhatsApp APK Download Latest Version',
				description:
					'YoWhatsApp explained: features, comparison with GBWhatsApp, download and install steps, privacy guidance, FAQ, plus links to FMWhatsApp, OGWhatsApp, and downloads.',
				keywords: 'yowhatsapp, yo whatsapp download',
			},
			in: {
				title: 'YoWhatsApp APK डाउनलोड नवीनतम संस्करण',
				description: 'YoWhatsApp की सुविधाएँ, GBWhatsApp से तुलना, डाउनलोड और इंस्टॉल स्टेप्स, privacy guidance और FAQ।',
				keywords: 'yowhatsapp, yo whatsapp download',
			},
			es: {
				title: 'Descargar YoWhatsApp APK última versión',
				description: 'Funciones de YoWhatsApp, comparación con GBWhatsApp, descarga, instalación segura y FAQ.',
				keywords: 'yowhatsapp, yo whatsapp download',
			},
			pt: {
				title: 'Baixar YoWhatsApp APK última versão',
				description: 'Recursos do YoWhatsApp, comparação com GBWhatsApp, download seguro, instalação e FAQ.',
				keywords: 'yowhatsapp, yo whatsapp download',
			},
			id: {
				title: 'Unduh YoWhatsApp APK versi terbaru',
				description: 'Fitur YoWhatsApp, perbandingan dengan GBWhatsApp, langkah unduh, instalasi aman, dan FAQ.',
				keywords: 'yowhatsapp, yo whatsapp download',
			},
		},
		ogwhatsapp: {
			en: {
				title: 'OGWhatsApp APK Download Latest Version',
				description:
					'OGWhatsApp overview, parallel-install use cases, vs GBWhatsApp, download and install, privacy, FAQ, and internal links to FMWhatsApp, YoWhatsApp, and the site home.',
				keywords: 'ogwhatsapp, og whatsapp apk',
			},
			in: {
				title: 'OGWhatsApp APK डाउनलोड नवीनतम संस्करण',
				description: 'OGWhatsApp overview, parallel install use case, GBWhatsApp से तुलना, डाउनलोड, इंस्टॉल, privacy और FAQ।',
				keywords: 'ogwhatsapp, og whatsapp apk',
			},
			es: {
				title: 'Descargar OGWhatsApp APK última versión',
				description: 'Resumen de OGWhatsApp, uso paralelo, comparación con GBWhatsApp, descarga segura, instalación y FAQ.',
				keywords: 'ogwhatsapp, og whatsapp apk',
			},
			pt: {
				title: 'Baixar OGWhatsApp APK última versão',
				description: 'Visão geral do OGWhatsApp, uso paralelo, comparação com GBWhatsApp, download, instalação e FAQ.',
				keywords: 'ogwhatsapp, og whatsapp apk',
			},
			id: {
				title: 'Unduh OGWhatsApp APK versi terbaru',
				description: 'Gambaran OGWhatsApp, skenario instalasi paralel, perbandingan dengan GBWhatsApp, unduhan aman, instalasi, dan FAQ.',
				keywords: 'ogwhatsapp, og whatsapp apk',
			},
		},
		bluewhatsapp: {
			en: {
				title: 'BlueWhatsApp APK Download Latest Version',
				description:
					'BlueWhatsApp MOD context: branding caveats, features, vs GBWhatsApp, download and install, security notes, FAQ, and links to FM, Yo, OG, and the download hub.',
				keywords: 'blue whatsapp, whatsapp mod apk',
			},
			in: {
				title: 'BlueWhatsApp APK डाउनलोड नवीनतम संस्करण',
				description: 'BlueWhatsApp MOD context, branding caveats, GBWhatsApp से तुलना, डाउनलोड, इंस्टॉल, security notes और FAQ।',
				keywords: 'blue whatsapp, whatsapp mod apk',
			},
			es: {
				title: 'Descargar BlueWhatsApp APK última versión',
				description: 'Contexto de BlueWhatsApp MOD, branding, comparación con GBWhatsApp, descarga segura, instalación y FAQ.',
				keywords: 'blue whatsapp, whatsapp mod apk',
			},
			pt: {
				title: 'Baixar BlueWhatsApp APK última versão',
				description: 'Contexto do MOD BlueWhatsApp, comparação com GBWhatsApp, download seguro, instalação, notas de segurança e FAQ.',
				keywords: 'blue whatsapp, whatsapp mod apk',
			},
			id: {
				title: 'Unduh BlueWhatsApp APK versi terbaru',
				description: 'Konteks MOD BlueWhatsApp, perbandingan dengan GBWhatsApp, unduhan aman, instalasi, catatan keamanan, dan FAQ.',
				keywords: 'blue whatsapp, whatsapp mod apk',
			},
		},
	};
	const t = titles[mod]?.[locale] || titles[mod]?.en || titles.fmwhatsapp.en;
	const seg = `mods/${mod}`;
	return {
		locale,
		hreflangSegment: seg,
		title: t.title,
		description: t.description,
		keywords: t.keywords,
		link: [{ rel: 'canonical', href: absoluteUrl(locale, seg) }],
		hreflangHtml: buildHreflangLinkTags(seg),
	};
}

function blogPostMeta(locale, post) {
	const m = post.meta[locale] || post.meta.en;
	const seg = `blog/${post.slug}`;
	return {
		locale,
		hreflangSegment: seg,
		title: m.title,
		description: m.description,
		keywords: m.keywords,
		link: [{ rel: 'canonical', href: absoluteUrl(locale, seg) }],
		hreflangHtml: buildHreflangLinkTags(seg),
	};
}

export function buildAppRoutes() {
	const routes = [];
	const staticEnglishOnlySegments = ['download', 'old-versions', 'for-pc', 'for-web', 'features', 'mods', 'blog', 'about', 'contact', 'privacy-policy', 'terms-of-service', 'dmca'];
	const mods = ['fmwhatsapp', 'yowhatsapp', 'ogwhatsapp', 'bluewhatsapp'];

	const add = (localeCode, segment, routeName, componentLoader, pageKey, extraMeta = {}) => {
		routes.push({
			path: localeUrl(localeCode, segment),
			name: `${localeCode}-${routeName}`,
			component: componentLoader,
			meta: { ...routeMeta(localeCode, segment, pageKey), ...extraMeta },
		});
	};

	const addLegacyRedirect = (localeCode, segment) => {
		routes.push({
			path: localeUrl(localeCode, segment),
			redirect: localeUrl('en', segment),
		});
	};

	for (const loc of LOCALES) {
		const lc = loc.code;
		add(lc, '', 'home', () => import('@/views/seo/HomePage.vue'), 'home');
		if (lc !== 'en') {
			for (const segment of staticEnglishOnlySegments) addLegacyRedirect(lc, segment);
			for (const mod of mods) addLegacyRedirect(lc, `mods/${mod}`);
			for (const post of blogPosts) addLegacyRedirect(lc, `blog/${post.slug}`);
			continue;
		}

		add(lc, 'download', 'download', () => import('@/views/seo/DownloadPage.vue'), 'download');
		add(lc, 'old-versions', 'old-versions', () => import('@/views/seo/OldVersionsPage.vue'), 'oldVersions');
		add(lc, 'for-pc', 'for-pc', () => import('@/views/seo/ForPcPage.vue'), 'forPc');
		add(lc, 'for-web', 'for-web', () => import('@/views/seo/ForWebPage.vue'), 'forWeb');
		add(lc, 'features', 'features', () => import('@/views/seo/FeaturesPage.vue'), 'features');
		add(lc, 'mods', 'mods-index', () => import('@/views/seo/ModsIndexPage.vue'), 'modsIndex');
		add(lc, 'blog', 'blog-index', () => import('@/views/seo/BlogIndexPage.vue'), 'blogIndex');
		add(lc, 'about', 'about', () => import('@/views/seo/LegalPage.vue'), 'about', { legal: 'about' });
		add(lc, 'contact', 'contact', () => import('@/views/seo/LegalPage.vue'), 'contact', { legal: 'contact' });
		add(lc, 'privacy-policy', 'privacy', () => import('@/views/seo/LegalPage.vue'), 'privacy', { legal: 'privacy' });
		add(lc, 'terms-of-service', 'terms', () => import('@/views/seo/LegalPage.vue'), 'terms', { legal: 'terms' });
		add(lc, 'dmca', 'dmca', () => import('@/views/seo/LegalPage.vue'), 'dmca', { legal: 'dmca' });

		for (const mod of mods) {
			routes.push({
				path: localeUrl(lc, `mods/${mod}`),
				name: `${lc}-mod-${mod}`,
				component: () => import('@/views/seo/ModPage.vue'),
				meta: modMeta(lc, mod),
				props: () => ({ mod }),
			});
		}

		for (const post of blogPosts) {
			routes.push({
				path: localeUrl(lc, `blog/${post.slug}`),
				name: `${lc}-blog-${post.slug.replace(/[^a-z0-9-]/gi, '-')}`,
				component: () => import('@/views/seo/BlogPostPage.vue'),
				meta: blogPostMeta(lc, post),
				props: () => ({ slug: post.slug }),
			});
		}
	}

	return routes;
}
